'use client';

import { useRouter, useSearchParams } from 'next/navigation';

import Paginator from './Paginator';
import ProductCard, { ProductType } from './ProductCard';

type ProductListViewProps = {
  list: ProductType[];
  total?: number;
  paginator?: {
    canGoNext?: boolean;
    canGoPrev?: boolean;
    onNext?: () => void;
    onPrev?: () => void;
    nextPage?: number;
    prevPage?: number;
  };
  className?: string;
  inOnSale?: boolean;
};

export const ProductListView: React.FC<ProductListViewProps> = ({ list, className, paginator, inOnSale }) => {
  const router = useRouter();
  const searchParams = useSearchParams();

  const handleNextPage = () => {
    if (paginator?.nextPage) {
      const params = new URLSearchParams(searchParams.toString());
      params.set('page', paginator.nextPage.toString());
      router.push(`?${params.toString()}`);
    } else if (paginator?.onNext) {
      paginator.onNext();
    }
  };

  const handlePrevPage = () => {
    if (paginator?.prevPage) {
      const params = new URLSearchParams(searchParams.toString());
      params.set('page', paginator.prevPage.toString());
      router.push(`?${params.toString()}`);
    } else if (paginator?.onPrev) {
      paginator.onPrev();
    }
  };

  return (
    <div className={className}>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
        {list.map((product, index) => (
          <div key={product.id || index} className="">
            <ProductCard callbackUrl={`/products/${product.id}/${encodeURIComponent(product.name || '')}`} size="full" product={product} className="" inOnSale={inOnSale} />
          </div>
        ))}
      </div>

      {paginator && (paginator.canGoNext || paginator.canGoPrev) && (
        <Paginator
          canGoNext={paginator.canGoNext || false}
          canGoPrev={paginator.canGoPrev || false}
          nextPage={paginator.nextPage}
          prevPage={paginator.prevPage}
          goNextPage={handleNextPage}
          goPrevPage={handlePrevPage}
        />
      )}
    </div>
  );
};

export default ProductListView;
